// You can write more code here

import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { waitForMilliseconds } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

export interface SquareSelectableCardData {
  index: number;
  onCardSelected: (card: SquareSelectableCard) => void;
}

/* START OF COMPILED CODE */

export default class SquareSelectableCard extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // cardBacking
    const cardBacking = scene.add.image(0, 0, 'Hud2');
    cardBacking.scaleX = 2;
    cardBacking.scaleY = 2;
    this.add(cardBacking);

    this.cardBacking = cardBacking;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  public cardBacking: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  isSelected: boolean = false;
  hoverSFX: any;
  submitSFX: any;
  static hoverSFXTimeout: number = 100;
  static canPlayHoverSFX: boolean = true;
  onCardSelected: (card: SquareSelectableCard) => void = () => {};

  awake(data: SquareSelectableCardData) {
    const { scene, cardBacking } = this;

    this.onCardSelected = data.onCardSelected;

    cardBacking.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });

    cardBacking.on('pointerover', () => {
      if (SquareSelectableCard.canPlayHoverSFX) {
        PhaserAudioManager.playSFX(scene, 'hover-click');
        SquareSelectableCard.canPlayHoverSFX = false;
        waitForMilliseconds(
          scene.time,
          SquareSelectableCard.hoverSFXTimeout,
        ).then(() => {
          SquareSelectableCard.canPlayHoverSFX = true;
        });
      }
      this.setScale(1.1);
    });

    cardBacking.on('pointerout', () => {
      this.setScale(1);
    });

    cardBacking.on('pointerdown', () => {
      this.onCardSelected(this);
    });

    return this;
  }

  setCardInteractive(isInteractive: boolean) {
    const { cardBacking } = this;
    if (isInteractive) {
      cardBacking.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
    } else {
      cardBacking.disableInteractive();
    }
  }

  selectCard(playSFX: boolean = true) {
    // Select the card.
    const { cardBacking } = this;
    cardBacking?.setTexture('Hud2-select');
    if (playSFX) {
      PhaserAudioManager.playSFX(this.scene, 'submit-click');
    }
    this.isSelected = true;
  }

  deselectCard() {
    // Deselect the card.
    const { cardBacking } = this;
    cardBacking.setTexture('Hud2');
    this.isSelected = false;
  }

  toggleCard() {
    if (this.isSelected) {
      this.deselectCard();
    } else {
      this.selectCard();
    }
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.cardBacking.displayWidth,
      this.cardBacking.displayHeight,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
